import { render } from "./DollarIcon.vue?vue&type=template&id=69b8b0bc"
const script = {}
script.render = render

export default script